/* HARPAH Black Friday V3 FIX: Klaviyo direct subscription only; no automatic native Shopify fallback or hCaptcha detour. */
(function(){
 'use strict';
 const ROOT_SELECTOR='[data-hbf-root]';
 function isValidPublicId(v){return /^[a-zA-Z0-9_-]{3,24}$/.test(v||'');}
 function feedback(form,message,state){const el=form.querySelector('[data-hbf-message]');if(el){el.textContent=message;el.dataset.state=state;}}
 function setBusy(form,busy){const btn=form.querySelector('button[type="submit"]');if(btn){btn.disabled=busy;btn.setAttribute('aria-busy',busy?'true':'false');}}
 function confirmationUrl(root){
  const raw=(root.dataset.successUrl||'').trim();
  if(!raw)return new URL('/pages/black-friday-early-access-confirmation',window.location.origin).href;
  try{const url=new URL(raw,window.location.origin);return url.origin===window.location.origin ? url.href : '';}catch(_){return '';}
 }
 function redirectIfConfigured(root){
  const url=confirmationUrl(root);
  if(url)window.location.assign(url);
 }
 function signupError(form,message){feedback(form,message || 'We could not complete your registration. Please try again.','error');}
 async function subscribe(root,form){
  const email=form.querySelector('input[type="email"]');const consent=form.querySelector('[data-hbf-consent]');
  if(!email || !email.checkValidity()){email&&email.reportValidity();return;}
  if(!consent || !consent.checked){consent&&consent.reportValidity();return;}
  const enabled=root.dataset.klaviyoEnabled==='true';const site=(root.dataset.klaviyoSite||'').trim();const list=(root.dataset.klaviyoList||'').trim();
  if(!enabled || !isValidPublicId(site) || !isValidPublicId(list)){signupError(form,'Black Friday registration is temporarily unavailable. Please contact HARPAH support.');return;}
  setBusy(form,true);feedback(form,'Submitting your request…','info');
  const ctrl=new AbortController();const timeout=setTimeout(()=>ctrl.abort(),10000);
  try{
   const payload={data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email.value.trim(),subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:list}}}}};
   const res=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(site),{method:'POST',mode:'cors',headers:{'accept':'application/vnd.api+json','content-type':'application/vnd.api+json','revision':'2025-07-15'},body:JSON.stringify(payload),signal:ctrl.signal});
   if(res.status===202){feedback(form,'You’re on the list! Check your inbox for updates or a confirmation email.','success');form.reset();root.dispatchEvent(new CustomEvent('harpah:black-friday:signup',{detail:{provider:'klaviyo'},bubbles:true}));redirectIfConfigured(root);return;}
   if(res.status===429 || res.status>=500){signupError(form,'The signup service is temporarily busy. Please try again shortly.');return;}
   feedback(form,'We could not complete your subscription. Please check your details and try again.','error');
  }catch(err){signupError(form,'We could not reach the signup service. Check your connection and try again.');}finally{clearTimeout(timeout);setBusy(form,false);}
 }
 function initCountdown(root){
  const section=root.querySelector('[data-hbf-countdown]');
  if(!section || section.dataset.hbfClockInitialized==='true')return;
  section.dataset.hbfClockInitialized='true';
  const raw=(section.dataset.target||'').trim();
  // Require explicit time zone to prevent browser-local clock disagreements.
  const valid=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw);
  const parsed=valid?Date.parse(raw):NaN;
  if(!Number.isFinite(parsed)){
   // An unset or malformed campaign launch date must never create fake urgency.
   section.hidden=true;
   return;
  }
  const status=section.querySelector('[data-hbf-countdown-status]');
  const clock=section.querySelector('.hbf__clock');
  const fields=['days','hours','minutes','seconds'].map(unit=>section.querySelector('[data-hbf-'+unit+']'));
  const pad=n=>String(n).padStart(2,'0');
  let interval;
  const tick=()=>{
   const seconds=Math.max(0,Math.ceil((parsed-Date.now())/1000));
   if(seconds===0){
    if(interval)clearInterval(interval);
    if(section.dataset.expiredBehavior==='hide'){section.hidden=true;return;}
    if(clock)clock.hidden=true;
    if(status){status.hidden=false;status.textContent='Private access has begun. Watch your inbox for your invitation.';}
    return;
   }
   const d=Math.floor(seconds/86400),h=Math.floor(seconds%86400/3600),m=Math.floor(seconds%3600/60),s=seconds%60;
   [d,h,m,s].forEach((n,i)=>{if(fields[i])fields[i].textContent=pad(n);});
  };
  tick();
  if(parsed>Date.now()){
   interval=setInterval(tick,1000);
   root.addEventListener('shopify:section:unload',()=>clearInterval(interval),{once:true});
  }
 }
 function init(root){
  if(root.dataset.hbfInitialized==='true')return;
  root.dataset.hbfInitialized='true';
  initCountdown(root);
 }
 // Document capture intercepts both forms before any native submit handler and
 // survives Shopify theme editor rendering/replacing sections.
 document.addEventListener('submit',function(e){
  const form=e.target;
  if(!(form instanceof HTMLFormElement) || !form.matches('form[data-hbf-form]'))return;
  const root=form.closest(ROOT_SELECTOR);
  if(!root)return;
  e.preventDefault();e.stopPropagation();
  if(e.stopImmediatePropagation)e.stopImmediatePropagation();
  if(form.dataset.hbfPending==='true')return;
  form.dataset.hbfPending='true';
  subscribe(root,form).finally(()=>{delete form.dataset.hbfPending;});
 },true);
 document.querySelectorAll(ROOT_SELECTOR).forEach(init);
 document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll(ROOT_SELECTOR).forEach(init);});
})();
